    <ng-container *ngIf="controlTemplate?.settings?.value !== undefined && controlTemplate?.settings?.value !== null; else noValue">
        <div class="flex flex-row border-solid border-gray-300 last:border-b-0">
            <div class="basis-1/2 py-2">Gesamt:</div>
            <div class="basis-1/2 py-2 text-right">{{controlTemplate?.settings?.value?.sum | secondsToDuration}}</div>
        </div>
        <div
            *ngIf="controlTemplate?.settings?.value?.timeEntries; else noValue">
            <table
                class="time-entries-table">
                <thead class="time-entries-table">
                    <tr>
                        <th>Start</th>
                        <th>Ende</th>
                        <th>Pause</th>
                        <th>Dauer</th>
                        <th>Kategorie</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let timeEntry of controlTemplate?.settings?.value?.timeEntries; let isLast = last">
                        <td class="text">{{timeEntry.startDateTime | date:'dd.MM.yy HH:mm'}}</td>
                        <td class="text">{{timeEntry.endDateTime | date:'dd.MM.yy HH:mm'}}</td>
                        <td class="text">{{timeEntry.pauseDuration | secondsToDuration}}</td>
                        <td class="text">{{timeEntry.duration | secondsToDuration}}</td>
                        <td class="text">{{timeEntry.category?.name}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-template #noValue>
            <div
                class="text-base text-[#848488] font-light text-center">
                Keine Zeiteinträge vorhanden.
            </div>
        </ng-template>
    </ng-container>
    <ng-template #noValue>
        -
    </ng-template>